import { render, staticRenderFns } from "./club-activity-item.vue?vue&type=template&id=45e20f7a&scoped=true&"
import script from "./club-activity-item.vue?vue&type=script&lang=js&"
export * from "./club-activity-item.vue?vue&type=script&lang=js&"
import style0 from "./club-activity-item.vue?vue&type=style&index=0&id=45e20f7a&lang=scss&scoped=true&"
import style1 from "./club-activity-item.vue?vue&type=style&index=1&id=45e20f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e20f7a",
  null
  
)

export default component.exports